export enum TemplateType
{
    InvoiceResend = 0,
    DeliveryConfirmationDelivery = 1,
    DeliveryConfirmationPickup = 2,
    CreditConfirmation = 3,
    ContainerLoadPickupRequisition = 4,
    DeliveryScheduleFinal = 5,
    CodNoticeToAccounting = 6,
    ContainerBillOfLading = 7,
    DeliverySchedulePreliminary = 8,
    InvoiceBillingOnly = 9,
    NoDriverAssignedAlert = 10,
    ProductionSummary = 11,
    MonthlyDealerStatement = 12,
    CreditHoldChange = 13,
    CreditHoldReasonChange = 14,
    NoTrailerAlert = 15,
}

export const TemplateTypeMetadata = {
    '0': {
        display: 'Invoice Resent',
        value: 0
    },
    '1': {
        display: 'Invoice Confirmation: Delivery',
        value: 1
    },
    '2': {
        display: 'Invoice Confirmation : Pickup',
        value: 2
    },
    '3': {
        display: 'Credit Confirmation',
        value: 3
    },
    '4': {
        display: 'Container Load Pickup Requisition',
        value: 4
    },
    '5': {
        display: 'Delivery Schedule Final',
        value: 5
    },
    '6': {
        display: 'COD Notice to Accounting',
        value: 6
    },
    '7': {
        display: 'Container Bill Of Lading',
        value: 7
    },
    '8': {
        display: 'Delivery Schedule Preliminary',
        value: 8
    },
    '9': {
        display: 'Invoice Billing Only',
        value: 9
    },
    '10': {
        display: 'No Driver Assigned Alert',
        value: 10
    },
    '11': {
        display: 'Production Summary',
        value: 11
    },
    '12': {
        display: 'Monthly Dealer Statement',
        value: 12
    },
    '13': {
        display: 'Credit Hold Change',
        value: 13
    },
    '14': {
        display: 'Credit Hold Reason Change',
        value: 14
    },
    '15': {
        display: 'No Trailer Alert',
        value: 15
    }
};
